module.exports = __webpack_public_path__ + "static/img/12.715ee10.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/zh/12.png
// module id = vv0u
// module chunks = 0